import React, { memo } from 'react';

import { Card } from '../Card';

import style from './style.module.css';

const TableCardComponent = ({ className, title, actions, children }) => (
  <Card actions={actions} className={className} title={title} flush>
    <div className={style.body}>{children}</div>
  </Card>
);

/** Flush card around a plain HTML table: the body scrolls and the table header stays pinned. */
export const TableCard = memo(TableCardComponent);
